// AI-ASSISTED: generated with claude-code on 2026-08-17, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { PerformanceDashboardCard } from './PerformanceDashboardCard';

const performanceDashboardCard = EntityCardBlueprint.make({
  name: 'performance-dashboard',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { PerformanceDashboardCard } = await import('./PerformanceDashboardCard');
      return <PerformanceDashboardCard />;
    },
  },
});

export const performanceDashboardCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [performanceDashboardCard],
});
